

















import { defineComponent } from '@vue/composition-api'
import { ModalComposition } from '@/composition/UseModalComposition'
import { HomePresenter } from '@/containers/Home/UseHomePresenter'

// ================================
// Props
// ================================
export type SectionMovieListProps = {
  modal: ModalComposition;
  viewDatas: HomePresenter;
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'SectionMovieList',
  props: ['modal', 'viewDatas'],
  setup (props: SectionMovieListProps) {
    return {
      props
    }
  }
})
